var GoSubWidget = (function () {
  function e() {
    (this.attrs = {
      purchaseOptionOneTime: "data-gosub-purchase-option-one-time",
      sellingPlanGroupId: "data-gosub-selling-plan-group-id",
      hideGroupProductSettings: "data-hide-group-product-settings",
      sellingPlanIdInput: "data-gosub-selling-plan-id-input",
      widget: "data-gosub-product",
      sellingPlanOptionsContainer: "data-gosub-selling-plan-options-container",
      sellingPlanOption: "data-gosub-selling-plan-option",
      sellingPlansContainer: "data-gosub-selling-plans-container",
      sellingPlanGroup: "data-gosub-selling-plan-group",
      sellingPlanGroupInput: "data-gosub-selling-plan-group-input",
      sellingPlan: "data-gosub-selling-plan",
      sellingPlanInput: "data-gosub-selling-plan-input",
      productJson: "data-gosub-product-json",
      groupDiscountSummary: "data-gosub-group-discount-summary",
      perDeliveryPrice: "data-gosub-per-delivery-price",
      cartPopupDetails: "data-gosub-cart-popup-details",
      cartPageDetails: "data-gosub-cart-page-details",
      moneyFormat: "data-gosub-money-format",
      pageTemplate: "data-gosub-page-template",
    }),
      (this.selectors = {
        productForm: 'form[action*="/cart/add"]',
        variantIdInput: '[name="id"]',
        variantSelector: [
          "#shappify-variant-id",
          ".single-option-selector",
          "select[name=id]",
          "input[name=id]",
          ".product-form__single-variant-select",
        ],
        sellingPlanGroupButton: ".gosub-widget__group",
        priceDiv: [
          ".product .price__container",
          '[ref="priceContainer"]',
          ".product price-list",
        ],
      }),
      Object.entries(this.attrs).forEach(
        function ([e, t]) {
          this.selectors[e] = `[${t}]`;
        }.bind(this)
      ),
      (this.classes = {
        hidden: "gosub__hidden",
        selected: "gosub__plan-selected",
      }),
      (this.products = {}),
      (this.variants = {}),
      (this.sellingPlanGroups = {}),
      (this.pageTemplate = "");
  }
  return (
    (e.prototype = Object.assign({}, e.prototype, {
      init: function (e) {
        if (
          (console.debug("GORIDE SUBSCRIPTION LOADING..."),
          !document.querySelector(this.selectors.widget))
        )
          return void console.debug("GORIDE SUB SKIPPED LOADING");
        this._parsePageTemplate(),
          this._parseProductJson(),
          this._addVariantChangeListener();
        const t = document.querySelectorAll(this.selectors.productForm);
        t?.forEach((e) => {
          const t = e.querySelector('input[name="id"]');
          if (!t) return;
          let n = t.value;
          new MutationObserver(() => {
            if (t.value !== n) {
              n = t.value;
              var s = e?.querySelector(this.selectors.widget);
              this._renderPrices(s);
            }
          }).observe(t, { attributes: !0, attributeFilter: ["value"] });
        }),
          (e && e.length
            ? e
            : document.querySelectorAll(this.selectors.widget)
          ).forEach(
            function (e) {
              this._renderPrices(e),
                this._translateContent(e),
                this._checkPlanLimit(e);
            }.bind(this)
          ),
          window.addEventListener(
            "pageshow",
            function () {
              this.syncAllVisuallySelected();
            }.bind(this)
          ),
          t?.forEach((e) => {
            const t = document.querySelector(".gosub-widget__wrapper");
            new MutationObserver(() => {
              t && this._handlePriceDivChange(t);
            }).observe(e, { childList: !0, subtree: !0 }),
              t && this._handlePriceDivChange(t);
          }),
          console.debug("GORIDE SUBSCRIPTION LOAD SUCCESSFUL");
      },
      syncAllVisuallySelected: function () {
        document
          .querySelectorAll(this.selectors.widget)
          .forEach(this._syncVisuallySelected.bind(this));
      },
      _syncVisuallySelected: function (e) {
        e.querySelector(
          `${this.selectors.sellingPlanGroupInput}:checked`
        ).dispatchEvent(new Event("change"));
      },
      _addVariantChangeListener: function () {
        document
          .querySelectorAll(this.selectors.variantSelector.join())
          .forEach(
            function (e) {
              e &&
                e.addEventListener(
                  "change",
                  function (e) {
                    var t = e.target.closest(this.selectors.productForm);
                    t || console.log("product form not found");
                    var n = t?.querySelector(this.selectors.widget);
                    setTimeout(
                      function () {
                        this._renderPrices(n);
                      }.bind(this),
                      100
                    );
                  }.bind(this)
                );
            }.bind(this)
          );
      },
      _parsePageTemplate: function () {
        var e = document.querySelector(this.selectors.pageTemplate);
        null !== e && (this.pageTemplate = e.value);
      },
      _parseProductJson: function () {
        document.querySelectorAll(this.selectors.productJson).forEach(
          function (e) {
            var t = JSON.parse(e.innerHTML);
            (this.products[e.dataset.gosubProductId] = t),
              t.selling_plan_groups.forEach(
                function (e) {
                  this.sellingPlanGroups[e.id] = e;
                }.bind(this)
              ),
              t.variants.forEach(
                function (e) {
                  this.variants[e.id] = e;
                }.bind(this)
              );
          }.bind(this)
        );
      },
      renderAllPrices: function () {
        console.log("widgets renderAllPrices"),
          document
            .querySelectorAll(this.selectors.widget)
            .forEach(this._renderPrices.bind(this));
      },
      _renderPrices: function (e) {
        const t = document
          .querySelector("div.gosub-widget__wrapper")
          .classList.contains("gosub-widget__wrapper--multi-group");
        null == e && (e = document.querySelector(this.selectors.widget));
        var n = e.querySelectorAll(this.selectors.sellingPlan),
          s = this._getVariantId(e);
        if (s) {
          const o = document.querySelector(".gosub-widget__wrapper"),
            l = o?.getAttribute("data-hide-group-product-settings");
          let i = null;
          try {
            i = l ? JSON.parse(l) : null;
          } catch (e) {
            console.error(
              "Invalid JSON in data-hide-group-product-settings",
              e
            );
          }
          const a =
            i &&
            Object.values(i)?.some(
              (e) =>
                Array.isArray(e) &&
                e?.includes(`gid://shopify/ProductVariant/${s}`)
            );
          if (
            (n.forEach(
              function (n) {
                var o = n.dataset.gosubSellingPlanId,
                  l = this._getSellingPlanAllocation(s, o),
                  i = document.getElementsByClassName("gosub-widget__group")[1],
                  a = document.getElementsByClassName(
                    "gosub-widget__plans-container"
                  )[0],
                  r = n.querySelector(this.selectors.perDeliveryPrice);
                if (null != l) {
                  t
                    ? n.classList.remove(this.classes.hidden)
                    : null != i &&
                      (i.classList.remove(this.classes.hidden),
                      null == a ||
                        e.querySelector("input[value=once]")?.checked ||
                        a.classList.remove(this.classes.hidden));
                  var c = l.per_delivery_price,
                    u = this._formatPrice(c);
                  r.innerHTML = u;
                } else
                  t
                    ? n.classList.add(this.classes.hidden)
                    : i.classList.add(this.classes.hidden),
                    a.classList.add(this.classes.hidden);
              }.bind(this)
            ),
            t)
          ) {
            const t = document.querySelectorAll(
                ".gosub-widget__plans-container"
              ),
              n = document.querySelector("fieldset.gosub-product"),
              o = document.querySelector(
                ".gosub-widget__groups-container .gosub-widget__group:last-child"
              );
            n.classList.remove("gosub__hidden"),
              o.classList.remove("gosub__hidden"),
              document
                .querySelector(".gosub-widget__groups-container")
                .classList.contains("default-subscription-selected") &&
                document
                  .querySelectorAll("input[value=subscription]")[0]
                  ?.click();
            for (const e of t) e.classList.remove("gosub__hidden");
            const l = document.querySelectorAll(
              ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
            );
            for (const e of l) {
              const t = e.dataset.gosubSellingPlanGroupId;
              if (
                a &&
                i[t] &&
                i[t].includes(`gid://shopify/ProductVariant/${s}`)
              ) {
                console.log(
                  `variant ${s} should be hidden from page for group ${t}, hiding group`
                ),
                  e.classList.add("gosub__hidden");
                continue;
              }
              e.querySelector(".gosub-widget__plan:not(.gosub__hidden)") ||
                e.classList.add("gosub__hidden");
            }
            const r = document.querySelector(
              ".gosub-widget__plans-container.gosub-widget__plans-container__multiple:not(.gosub__hidden)"
            );
            r ||
              (n.classList.add("gosub__hidden"),
              o.classList.add("gosub__hidden"),
              document.querySelectorAll("input[value=once]")[0]?.click());
            const c = (
                document
                  .querySelector("input[data-gosub-selling-plan-input]:checked")
                  ?.closest(".gosub-widget__plans-container") ||
                document.querySelector(".gosub-widget__plans-container")
              ).dataset.gosubSellingPlanGroupId,
              u = document.querySelector(
                ".gosub-widget__group.gosub__plan-selected input"
              ).value;
            let d = "once" === u ? "" : this._getActiveSellingPlanId(e, c);
            if (d) {
              console.log("adjusting labels");
              const e = r?.querySelectorAll(".gosub-widget__plan-label.active"),
                t = r?.querySelectorAll(".gosub-widget__plan-label");
              if (e?.length > 1) {
                console.log(
                  "multiple active labels in active group, remove extra actives"
                );
                for (const t of e) {
                  const e = t.querySelector(
                    "input[data-gosub-selling-plan-input]"
                  );
                  e?.value !== d && t.classList.remove("active");
                }
              } else if (0 == e?.length) {
                console.log("no active label in active group, set active one");
                for (const e of t) {
                  const t = e.querySelector(
                    "input[data-gosub-selling-plan-input]"
                  );
                  t?.value == d && e.classList.add("active");
                }
              }
              const n = r?.querySelectorAll(
                "input[data-gosub-selling-plan-input]:checked"
              );
              if (0 == n?.length) {
                const e = r?.querySelectorAll(
                  "input[data-gosub-selling-plan-input]"
                );
                if (e?.length > 0) {
                  (e[0].checked = !0), (d = e[0].value);
                  e[0]
                    .closest(".gosub-widget__plan-label")
                    .classList.add("active");
                }
              }
              const s = document?.querySelectorAll(
                ".gosub-widget__plan-label.active"
              );
              if (s?.length > 1)
                for (const e of s) {
                  const t = e.querySelector(
                    "input[data-gosub-selling-plan-input]"
                  );
                  t?.checked || e.classList.remove("active");
                }
              const o = document?.querySelectorAll(
                "input[data-gosub-selling-plan-input]:checked"
              );
              if (o?.length > 1)
                for (const e of o)
                  if (e.value !== d) {
                    e.checked = !1;
                    e.closest(".gosub-widget__plan-label").classList.remove(
                      "active"
                    );
                  }
            }
            if ("once" === u) {
              document
                .getElementById("gosub-widget__plans-container-wrapper")
                .classList.add(this.classes.hidden);
            }
            this._setSellingPlanIdInput(e, d);
          } else {
            const t = document.querySelector("fieldset.gosub-product"),
              n = document.querySelector(
                ".gosub-widget__groups-container .gosub-widget__group:last-child"
              );
            t.classList.remove("gosub__hidden"),
              document
                .querySelector(".gosub-widget__groups-container")
                .classList.contains("default-subscription-selected") &&
                document.getElementById("inputSubscription")?.click(),
              n.classList.contains("gosub__hidden") &&
                (console.log(
                  "subscription plan is null in this variant, so hide select buttons"
                ),
                t.classList.add("gosub__hidden"),
                document.querySelectorAll("input[value=once]")[0]?.click());
            const o = document.querySelector(".gosub-widget__wrapper"),
              l = document.querySelector(
                ".gosub-widget__group.gosub__plan-selected input"
              ).value,
              r = "once" === l ? "" : this._getActiveSellingPlanId(e, l);
            this._setSellingPlanIdInput(e, r),
              a && i[l] && i[l].includes(`gid://shopify/ProductVariant/${s}`)
                ? (console.log(
                    `variant ${s} should be hidden from page for group ${l}, hiding group`
                  ),
                  o.classList.add("gosub__hidden"),
                  this._setSellingPlanIdInput(e, ""))
                : (console.log(
                    `variant ${s} should be shown for group ${l}, showing group`
                  ),
                  o.classList.remove("gosub__hidden"));
          }
          document
            .querySelectorAll(".gosub-discount-descriptions-container div")
            .forEach((e) => {
              e.classList.add("gosub__hidden");
            });
          const r = document
              .querySelector(".gosub-widget__plan-label.active")
              .closest(".gosub-widget__plans-container"),
            c = document
              .querySelector(".gosub-widget__plan-label.active")
              .closest(".gosub-widget__plan"),
            u = c.dataset.gosubSellingPlanCycle,
            d = c.dataset.gosubSellingPlanName,
            g = r.querySelector(
              `div[data-gosub-plan-cycle="${u}"][data-gosub-plan-name="${d}"]`
            );
          g && g.classList.remove("gosub__hidden"),
            setTimeout(() => {
              this._handlePriceDivChange(e);
            }, 50);
        }
      },
      handleSellingPlanGroupChange: function (e) {
        const t = this._getVariantId(e.target.closest(this.selectors.widget)),
          n = document.querySelector(".gosub-widget__wrapper"),
          s = n?.getAttribute("data-hide-group-product-settings");
        let o = null;
        try {
          o = s ? JSON.parse(s) : null;
        } catch (e) {
          console.error("Invalid JSON in data-hide-group-product-settings", e);
        }
        const l =
          o &&
          Object.values(o)?.some(
            (e) =>
              Array.isArray(e) &&
              e?.includes(`gid://shopify/ProductVariant/${t}`)
          );
        var i = e.target,
          a = i.value,
          r = i.closest(this.selectors.widget),
          c = r.querySelectorAll(this.selectors.sellingPlanGroupButton),
          u = r.querySelectorAll(this.selectors.sellingPlansContainer);
        c.forEach(
          function (e) {
            e.querySelector(this.selectors.sellingPlanGroupInput).checked
              ? e.classList.add(this.classes.selected)
              : e.classList.remove(this.classes.selected);
          }.bind(this)
        ),
          u.forEach(
            function (e) {
              e.dataset.gosubSellingPlanGroupId === a && i.checked
                ? e.classList.remove(this.classes.hidden)
                : e.classList.add(this.classes.hidden);
            }.bind(this)
          );
        document
          .querySelectorAll(".gosub-discount-descriptions-container div")
          .forEach((e) => {
            e.classList.add("gosub__hidden");
          });
        const d = document
            .querySelector(".gosub-widget__plan-label.active")
            .closest(".gosub-widget__plans-container"),
          g = document
            .querySelector(".gosub-widget__plan-label.active")
            .closest(".gosub-widget__plan"),
          p = g.dataset.gosubSellingPlanCycle,
          h = g.dataset.gosubSellingPlanName,
          _ = d.querySelector(
            `div[data-gosub-plan-cycle="${p}"][data-gosub-plan-name="${h}"]`
          );
        if ((_ && _.classList.remove("gosub__hidden"), "once" === a || l))
          return (
            console.log(
              "groupId is once or variant should be hidden from page, setting selling plan id to empty"
            ),
            this._setSellingPlanIdInput(r, ""),
            void this._handlePriceDivChange(r)
          );
        var b = this._getActiveSellingPlanId(r, a);
        this._setSellingPlanIdInput(r, b), this._handlePriceDivChange(r);
      },
      handleSellingPlanGroupChangeMultipleGroup: function (e) {
        const t = (
          document
            .querySelector("input[data-gosub-selling-plan-input]:checked")
            ?.closest(".gosub-widget__plans-container") ||
          document.querySelector(".gosub-widget__plans-container")
        ).dataset.gosubSellingPlanGroupId;
        var n = e.target,
          s = n.value,
          o = n.closest(this.selectors.widget),
          l = o.querySelectorAll(this.selectors.sellingPlanGroupButton);
        const i = document.getElementById(
          "gosub-widget__plans-container-wrapper"
        );
        l.forEach(
          function (e) {
            e.querySelector(this.selectors.sellingPlanGroupInput).checked
              ? e.classList.add(this.classes.selected)
              : e.classList.remove(this.classes.selected);
          }.bind(this)
        );
        document
          .querySelectorAll(".gosub-discount-descriptions-container div")
          .forEach((e) => {
            e.classList.add("gosub__hidden");
          });
        const a = document
            .querySelector(".gosub-widget__plan-label.active")
            .closest(".gosub-widget__plans-container"),
          r = document
            .querySelector(".gosub-widget__plan-label.active")
            .closest(".gosub-widget__plan"),
          c = r.dataset.gosubSellingPlanCycle,
          u = r.dataset.gosubSellingPlanName,
          d = a.querySelector(
            `div[data-gosub-plan-cycle="${c}"][data-gosub-plan-name="${u}"]`
          );
        if (
          (d && d.classList.remove("gosub__hidden"),
          "subscription" === s
            ? i.classList.remove(this.classes.hidden)
            : i.classList.add(this.classes.hidden),
          "once" === s)
        )
          return (
            this._setSellingPlanIdInput(o, ""),
            void this._handlePriceDivChange(o)
          );
        var g = this._getActiveSellingPlanId(o, t);
        const p = document.querySelector(
          ".gosub-widget__plans-container.gosub-widget__plans-container__multiple:not(.gosub__hidden)"
        );
        if ("once" !== s && g && p) {
          const e = p?.querySelectorAll(".gosub-widget__plan-label.active"),
            t = p?.querySelectorAll(".gosub-widget__plan-label");
          if (e?.length > 1) {
            console.log(
              "multiple active labels in active group, remove extra actives"
            );
            for (const t of e) {
              const e = t.querySelector("input[data-gosub-selling-plan-input]");
              e?.value !== g && t.classList.remove("active");
            }
          } else if (0 == e?.length) {
            console.log("no active label in active group, set active one");
            for (const e of t) {
              const t = e.querySelector("input[data-gosub-selling-plan-input]");
              t?.value == g && e.classList.add("active");
            }
          }
          const n = p?.querySelectorAll(
            "input[data-gosub-selling-plan-input]:checked"
          );
          if (0 == n?.length) {
            const e = p?.querySelectorAll(
              "input[data-gosub-selling-plan-input]"
            );
            if (e?.length > 0) {
              (e[0].checked = !0), (g = e[0].value);
              e[0].closest(".gosub-widget__plan-label").classList.add("active");
            }
          }
          const s = document?.querySelectorAll(
            ".gosub-widget__plan-label.active"
          );
          if (s?.length > 1)
            for (const e of s) {
              const t = e.querySelector("input[data-gosub-selling-plan-input]");
              t?.checked || e.classList.remove("active");
            }
          const o = document?.querySelectorAll(
            "input[data-gosub-selling-plan-input]:checked"
          );
          if (o?.length > 1)
            for (const e of o)
              if (e.value !== g) {
                e.checked = !1;
                e.closest(".gosub-widget__plan-label").classList.remove(
                  "active"
                );
              }
        }
        this._setSellingPlanIdInput(o, g), this._handlePriceDivChange(o);
      },
      handleSellingPlanChange: function (e) {
        var t = e.target,
          n = t.closest(this.selectors.widget);
        this._setSellingPlanIdInput(n, t.value);
        for (
          var s = document.getElementsByClassName("gosub-widget__plan-label"),
            o = 0;
          o < s.length;
          o++
        ) {
          s[o].classList.remove("active");
        }
        t.parentNode.classList.add("active");
        document
          .querySelectorAll(".gosub-discount-descriptions-container div")
          .forEach((e) => {
            e.classList.add("gosub__hidden");
          });
        const l = t.closest(".gosub-widget__plans-container"),
          i = t.closest(".gosub-widget__plan"),
          a = i.dataset.gosubSellingPlanCycle,
          r = i.dataset.gosubSellingPlanName,
          c = l.querySelector(
            `div[data-gosub-plan-cycle="${a}"][data-gosub-plan-name="${r}"]`
          );
        c && c.classList.remove("gosub__hidden"), this._handlePriceDivChange(n);
      },
      handleSellingPlanChangeMultipleGroup: function (e) {
        var t = e.target;
        if (!0 === t.checked) {
          var n = t.closest(this.selectors.widget);
          this._setSellingPlanIdInput(n, t.value);
          for (
            var s = document.getElementsByClassName("gosub-widget__plan-label"),
              o = 0;
            o < s.length;
            o++
          ) {
            s[o].classList.remove("active");
          }
          t.parentNode.classList.add("active");
          const e = t.closest(
            ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
          );
          document
            .querySelectorAll(
              ".gosub-widget__plans-container.gosub-widget__plans-container__multiple"
            )
            .forEach((t) => {
              if (e !== t) {
                const e = t.querySelector("input:checked");
                e && (e.checked = !1);
              }
            });
          document
            .querySelectorAll(".gosub-discount-descriptions-container div")
            .forEach((e) => {
              e.classList.add("gosub__hidden");
            });
          const l = t.closest(".gosub-widget__plan"),
            i = l.dataset.gosubSellingPlanCycle,
            a = l.dataset.gosubSellingPlanName,
            r = e.querySelector(
              `div[data-gosub-plan-cycle="${i}"][data-gosub-plan-name="${a}"]`
            );
          r && r.classList.remove("gosub__hidden");
        }
        this._handlePriceDivChange(n);
      },
      handleSellingPlanOptionChange: function (e) {
        var t = e.target.closest(this.selectors.widget),
          n = e.target.dataset.gosubSellingPlanGroupId,
          s = this._getSellingPlanOptions(t, n),
          o = this._getSellingPlanFromOptions(n, s);
        this._setSellingPlanIdInput(o.id);
      },
      _setSellingPlanIdInput: function (e, t) {
        const n = findClosestElements(e, "form[action*='/cart/add']");
        0 === n.length &&
          console.error(
            "gosub: Could not find target form at setSellingPlanIdInput"
          );
        if (window.location.pathname.includes("/product")) {
          const e = document.getElementsByClassName("SellingPlanInput");
          if (0 == e.length) {
            console.log("there is no input yet");
            const e = document.getElementsByTagName("form");
            for (let n = 0; n < e.length; n++) {
              if (e[n].action.includes("/cart/add"))
                ((s = document.createElement("input")).type = "hidden"),
                  (s.name = "selling_plan"),
                  (s.value = t),
                  s.classList.add("SellingPlanInput"),
                  s.setAttribute("data-gosub-selling-plan-id-input", ""),
                  e[n].prepend(s);
            }
          } else for (let n = 0; n < e.length; n++) e[n].value = t;
        } else {
          const e = n[0]?.querySelector(".SellingPlanInput");
          var s;
          if (e) e.value = t;
          else
            console.log("there is no input yet"),
              ((s = document.createElement("input")).type = "hidden"),
              (s.name = "selling_plan"),
              (s.value = t),
              s.classList.add("SellingPlanInput"),
              s.setAttribute("data-gosub-selling-plan-id-input", ""),
              n[0]?.prepend(s);
        }
        var o = this._getVariantId(e);
        (/.*(product).*/.test(this.pageTemplate) ||
          /.*(collections).*/.test(this.pageTemplate)) &&
          this._updateHistoryState(o, t);
      },
      _getSellingPlanGroup: function (e) {
        if (this.sellingPlanGroups[e]) return this.sellingPlanGroups[e];
        console.error("gosub: Selling plan group data not found.");
      },
      _getSellingPlanOptions: function (e, t) {
        var n = e.querySelectorAll(
            `${this.selectors.sellingPlanOption}[${this.attrs.sellingPlanGroupId}="${t}"]:checked`
          ),
          s = [];
        return (
          n.forEach(function (e) {
            s.push({ index: e.dataset.gosubOptionIndex, value: e.value });
          }),
          s
        );
      },
      _getSellingPlanFromOptions: function (e, t) {
        return this._getSellingPlanGroup(e).selling_plans.find(function (e) {
          return t.every(function (t) {
            return e.options[t.index].value === t.value;
          });
        });
      },
      _getVariantId: function (e) {
        var t = findClosestElements(e, "form[action*='/cart/add']");
        0 === t.length &&
          console.error("gosub: Could not find product form at getVariantId.");
        for (var n = 0; n < t.length; n++) {
          const e = t[n],
            s = t[n].querySelector(this.selectors.variantIdInput),
            o = e?.getAttribute("id") || "unknown";
          if (
            (!o || "string" != typeof o || !o?.includes("ProductFormUpsell")) &&
            s
          )
            return s.value;
        }
        return (
          console.error(
            "gosub: Could not find variant ID input at getVariantId."
          ),
          null
        );
      },
      _getActiveSellingPlanId: function (e, t) {
        var n = e.querySelector(`input[name=gosub-selling-plan-${t}]:checked`);
        return (
          n ||
            console.error(
              `gosub: Could not find active plan ID for group ${t}.`
            ),
          n.value
        );
      },
      _updateHistoryState: function (e, t) {
        if (!history.replaceState || !e) return;
        const n = new URL(window.location.href),
          s = new URLSearchParams(n.search);
        t ? s.set("selling_plan", t) : s.delete("selling_plan"),
          s.set("variant", e);
        const o =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          s.toString();
        window.history.replaceState({ path: o }, "", o);
      },
      _handlePriceDivChange: function (e) {
        const t = document.querySelector(this.selectors.priceDiv),
          n = "priceContainer" === t?.getAttribute("ref"),
          s = t?.querySelector("compare-at-price");
        if (!t || n || s) return;
        if (
          "once" !==
          document.querySelector(
            ".gosub-widget__group.gosub__plan-selected input"
          ).value
        ) {
          const n = document
              .querySelector(".gosub-widget__wrapper")
              .getAttribute("data-gosub-discount-label-color"),
            s = /[^\d]*\d[\d,.]*\d[^\d]*/;
          let o = Array.from(t.querySelectorAll("span, sale-price")).find((e) =>
            s.test(e.textContent.trim())
          );
          const l = o?.querySelector(".sr-only");
          l && o.removeChild(l);
          let i = null;
          const a = document.querySelectorAll(".gosub-widget__plans-container");
          for (const e of a)
            if (!e.classList.contains("gosub__hidden")) {
              const t = e.dataset.gosubSellingPlanGroupId,
                n = e.querySelector(
                  `input[name="gosub-selling-plan-${t}"]:checked`
                );
              if (n) {
                i = n;
                break;
              }
            }
          const r = i?.value,
            c = this._getSellingPlanAllocation(
              this._getVariantId(e),
              r
            )?.per_delivery_price,
            u = c,
            d = this.variants[this._getVariantId(e)]?.price;
          if (!(u < d)) {
            if (o && o.querySelector("s")) {
              const e = o.querySelector("s").textContent;
              o.textContent = e;
            }
            return;
          }
          if (o && o.querySelector("s")) {
            const t = this._formatPrice(
                this._getSellingPlanAllocation(this._getVariantId(e), r)
                  ?.per_delivery_price
              ),
              s = o.querySelector(".gosub-new-price-banner");
            s && (s.textContent = t);
            const l = e
                .querySelector(".gosub-widget__plan-label.active")
                .querySelector(".gosub-pricing-off"),
              i = o.querySelector(".gosub-pricing-off-price-div");
            i && o.removeChild(i);
            const a = l.cloneNode(!0);
            (a.style.color = "white"),
              (a.style.padding = "2px 10px 4px"),
              (a.style.backgroundColor = n || "black"),
              (a.style.borderRadius = "50px"),
              (a.style.fontSize = "0.8em"),
              a.classList.add("gosub-pricing-off-price-div"),
              (a.style.position = "relative"),
              (a.style.top = "-2px"),
              o.appendChild(a);
          } else if (o) {
            const t = document.createElement("s");
            (t.textContent = o.textContent),
              (o.textContent = ""),
              o.appendChild(t);
            const s = this._formatPrice(u),
              l = document.createElement("span");
            l.classList.add("gosub-new-price-banner"),
              (l.textContent = s),
              (l.style.marginRight = "6px"),
              (l.style.fontWeight = "bold"),
              (l.style.marginLeft = "4px"),
              o.appendChild(l);
            const i = e
              .querySelector(".gosub-widget__plan-label.active")
              .querySelector(".gosub-pricing-off")
              .cloneNode(!0);
            (i.style.color = "white"),
              (i.style.padding = "2px 10px 4px"),
              (i.style.backgroundColor = n || "black"),
              (i.style.borderRadius = "50px"),
              (i.style.fontSize = "0.8em"),
              i.classList.add("gosub-pricing-off-price-div"),
              (i.style.position = "relative"),
              (i.style.top = "-2px"),
              o.appendChild(i);
          }
        } else {
          const e = /[^\d]*\d[\d,.]*\d[^\d]*/;
          let n = Array.from(t.querySelectorAll("span, sale-price")).find((t) =>
            e.test(t.textContent.trim())
          );
          const s = n?.querySelector(".sr-only");
          if ((s && n.removeChild(s), n && n.querySelector("s"))) {
            const e = n.querySelector("s").textContent;
            n.textContent = e;
          }
        }
      },
      _getSellingPlanAllocation(e, t) {
        var n = this.variants[e];
        return n
          ? n.selling_plan_allocations.find(function (e) {
              return `${e.selling_plan_id}` === t;
            })
          : (console.error(`gosub: Could not find variant ID ${e}`), null);
      },
      _formatPrice(e, t) {
        var n = document.querySelector(this.selectors.moneyFormat),
          s = n ? n.getAttribute("data-gosub-money-format") : null;
        "string" == typeof e && (e = e.replace(".", ""));
        var o = "",
          l = /\{\{\s*(\w+)\s*\}\}/,
          i =
            t ||
            s ||
            theme.moneyFormat ||
            theme.strings.moneyFormat ||
            Shopify.money_format ||
            "$ {% raw %}{{ amount }}{% endraw %}";
        function a(e, t, n, s) {
          if (((n = n || ","), (s = s || "."), isNaN(e) || null === e))
            return 0;
          var o = (e = (e / 100).toFixed(t)).split(".");
          return (
            o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
            (o[1] ? s + o[1] : "")
          );
        }
        switch (i.match(l)[1]) {
          case "amount":
            o = a(e, 2);
            break;
          case "amount_no_decimals":
            o = a(e, 0);
            break;
          case "amount_with_comma_separator":
            o = a(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = a(e, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = a(e, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            o = a(e, 2, "'");
        }
        const r = i.replace(l, o),
          c = document.createElement("div");
        return (c.innerHTML = r), c.textContent;
      },
      _checkPlanLimit(e) {
        const t = e?.querySelector(".gosub-widget__wrapper"),
          n = document.querySelector("input[data-gosub-shop-url]").value;
        fetch(`${n}/apps/gosubscride/api/check-plan-limit`)
          .then((e) => e.json())
          .then((e) => {
            console.log("data", e);
            if ((e?.overLimit || !1) && t) {
              t.classList.add("gosub__hidden");
              const e = document?.querySelectorAll(
                'input[name="selling_plan"]'
              );
              for (let t = 0; t < e?.length; t++) e[t].value = "";
            }
          })
          .catch((e) => {
            console.log("Plan check error:", e);
          });
      },
      _translateContent(e) {
        const t = document.querySelector("input[data-gosub-locale]").value,
          n = document.querySelector("input[data-gosub-shop-url]").value,
          s = e.querySelector(".gosub-widget__wrapper");
        fetch(`${n}/apps/gosubscride/api/translations`)
          .then((e) => e.json())
          .then((n) => {
            const o = e.querySelectorAll(".gosub-pricing-off"),
              l = n?.translationObject,
              i = l?.[t];
            if (i) {
              o?.forEach((e) => {
                const t = e.getAttribute("data-gosub-discount-type"),
                  n = e.getAttribute("data-gosub-discount-value"),
                  s = e.getAttribute("data-gosub-discount-percentage");
                const o = i?.productPageDiscountAmount,
                  l = i?.productPageDiscountPercent;
                if ("fixed_amount" == t && o) {
                  const t = n,
                    s = o?.replace("{money}", t);
                  e.innerHTML = s;
                } else if ("price" == t) e.innerHTML = n;
                else if ("percentage" == t && l) {
                  const t = s,
                    n = l?.replace("{num}", t);
                  e.innerHTML = n;
                }
              });
              const e = document?.querySelector(
                  ".go-sub-purchase-option-subscription"
                ),
                t = i?.productPageSubscription,
                n = document?.querySelector(".go-sub-purchase-option-one-time"),
                s = i?.productPageOneTimePurchase;
              t && e && (e.innerHTML = t), s && n && (n.innerHTML = s);
            } else console.log("No translation found");
            s.classList.remove("go-sub-translation-no-display");
          })
          .catch((e) => {
            console.log("Translation error:", e),
              s.classList.remove("go-sub-translation-no-display");
          });
      },
    })),
    e
  );
})();
function findClosestElements(e, t) {
  let n = e.closest(t);
  if (n) return [n];
  const s = Array.from(document.querySelectorAll(t));
  return 0 === s.length
    ? []
    : s
        .map((t) => {
          const n = e.compareDocumentPosition(t);
          let s;
          return (
            (s =
              n & Node.DOCUMENT_POSITION_CONTAINED_BY
                ? 0
                : n & Node.DOCUMENT_POSITION_CONTAINS
                ? 1
                : n & Node.DOCUMENT_POSITION_FOLLOWING
                ? 3
                : n & Node.DOCUMENT_POSITION_PRECEDING
                ? 4
                : 5),
            { element: t, distance: s }
          );
        })
        .sort((e, t) => e.distance - t.distance)
        .map((e) => e.element);
}
document.addEventListener("DOMContentLoaded", function () {
  (window.GORIDE = window.GORIDE || {}),
    (window.GORIDE.GoSubWidget = new GoSubWidget()),
    window.GORIDE.GoSubWidget.init();
});
const quickAddDiv = document.querySelector(".quick-add.no-js-hidden");
if (quickAddDiv) {
  console.log("Quick Add exists → running GoSub code");
  const e = setInterval(() => {
    const t = document.querySelector(".product-quick-view__content");
    if (!t) return;
    function n() {
      const e = t.querySelector("[data-gosub-product]");
      e &&
        !e.dataset.gosubInitialized &&
        ((e.dataset.gosubInitialized = "true"),
        console.log("Running GoSub init inside modal"),
        (window.GORIDE = window.GORIDE || {}),
        (window.GORIDE.GoSubWidget = new GoSubWidget()),
        window.GORIDE.GoSubWidget.init());
    }
    clearInterval(e), n();
    new MutationObserver(() => {
      n();
    }).observe(t, { childList: !0, subtree: !0 });
  }, 200);
} else console.log("Quick Add div not found → skipping GoSub code");
